export const COUPON_SET_COUPON = 'coupon/COUPON_SET_COUPON';
export const COUPON_CLEAR_COUPON = 'coupon/COUPON_CLEAR_COUPON';
